import React from 'react';
import { Col, ControlLabel, FormGroup, FormControl } from 'react-bootstrap';
import { Field } from 'formik';

export const Select = ({ name, label, col, options, setFieldValueOf, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form: { setFieldValue } }) =>
                <FormGroup controlId={name}>
                    <Col componentClass={ControlLabel} sm={label.col}>
                        {label.text}                        
                    </Col>
                    <Col sm={col}>
                        <FormControl
                            componentClass="select"
                            onChange={(e) => {
                                field.onChange(e);
                                setFieldValueOf && setFieldValueOf(e, setFieldValue);
                            }}
                            value={Number(field.value)}
                            {...props}
                        >
                            {options && options.map((option) =>
                                <option
                                    key={option.value}
                                    value={option.value}
                                >
                                    {option.text}
                                </option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>
            }
        </Field>
    );
};